/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PipelinesChooser_team$ref: FragmentReference;
declare export opaque type PipelinesChooser_team$fragmentType: PipelinesChooser_team$ref;
export type PipelinesChooser_team = {|
  +id: string,
  +slug: string,
  +organization: ?{|
    +pipelines: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: string,
          +repository: ?{|
            +url: string
          |},
        |}
      |}>
    |}
  |},
  +permissions: {|
    +teamPipelineCreate: ?{|
      +allowed: boolean
    |}
  |},
  +$refType: PipelinesChooser_team$ref,
|};
export type PipelinesChooser_team$data = PipelinesChooser_team;
export type PipelinesChooser_team$key = {
  +$data?: PipelinesChooser_team$data,
  +$fragmentRefs: PipelinesChooser_team$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "pipelineAddSearch"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "teamSelector"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelinesChooser_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            },
            {
              "kind": "Literal",
              "name": "order",
              "value": "RELEVANCE"
            },
            {
              "kind": "Variable",
              "name": "search",
              "variableName": "pipelineAddSearch"
            },
            {
              "kind": "Variable",
              "name": "team",
              "variableName": "teamSelector"
            }
          ],
          "concreteType": "PipelineConnection",
          "kind": "LinkedField",
          "name": "pipelines",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PipelineEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Pipeline",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Repository",
                      "kind": "LinkedField",
                      "name": "repository",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamPermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "teamPipelineCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b69ea2c51cf2f11778f3d1c83e1a4105';

module.exports = node;
